import { render } from "./Cars.vue?vue&type=template&id=5d98644c&scoped=true"
import script from "./Cars.vue?vue&type=script&lang=js"
export * from "./Cars.vue?vue&type=script&lang=js"

import "./Cars.vue?vue&type=style&index=0&id=5d98644c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d98644c"]])

export default __exports__